module.exports = __webpack_public_path__ + "static/media/logo.b9099bf3.png";